import type { ClientPostFlagRequest } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevinePostEventsApi } from '@/features/api/hooks/grapevine-post-events/useGrapevinePostEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useFlagPost = () => {
  const queryClient = useQueryClient();
  const api = useGrapevinePostEventsApi();

  return useApiMutation({
    mutationFn: (clientPostFlagRequest: ClientPostFlagRequest) =>
      api.postFlagRequest({ clientPostFlagRequest }),
    onSuccess: (_, { postId }) =>
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.POST, { postId }]
      })
  });
};
